var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoundingBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7779_9133",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7779_9133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.74072 30.3951C7.00407 30.3951 6.38053 30.1399 5.87012 29.6295C5.3597 29.1191 5.10449 28.4955 5.10449 27.7589V8.23975C5.10449 7.50309 5.3597 6.87956 5.87012 6.36914C6.38053 5.85872 7.00407 5.60352 7.74072 5.60352H27.2599C27.9965 5.60352 28.62 5.85872 29.1305 6.36914C29.6409 6.87956 29.8961 7.50309 29.8961 8.23975V27.7589C29.8961 28.4955 29.6409 29.1191 29.1305 29.6295C28.62 30.1399 27.9965 30.3951 27.2599 30.3951H7.74072ZM7.74072 28.2076H27.2599C27.3721 28.2076 27.4749 28.1609 27.5684 28.0674C27.6619 27.9739 27.7086 27.8711 27.7086 27.7589V8.23975C27.7086 8.12755 27.6619 8.0247 27.5684 7.9312C27.4749 7.83772 27.3721 7.79098 27.2599 7.79098H7.74072C7.62853 7.79098 7.52568 7.83772 7.43217 7.9312C7.33869 8.0247 7.29196 8.12755 7.29196 8.23975V27.7589C7.29196 27.8711 7.33869 27.9739 7.43217 28.0674C7.52568 28.1609 7.62853 28.2076 7.74072 28.2076ZM9.84411 24.9264H25.2686L20.473 18.5322L16.3785 23.8607L13.4618 20.1308L9.84411 24.9264Z",
    fill: "black",
    fillOpacity: 0.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoundingBox);
export default __webpack_public_path__ + "static/media/bounding-box.aa60b7a33f5929b1bfece6664a84b419.svg";
export { ForwardRef as ReactComponent };